"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Urls_1 = require("./Urls");
function apiNode(url, _a, $id) {
    var get = _a.get, post = _a.post, put = _a.put, del = _a.del, patch = _a.patch;
    var func = function (id) { return $id(id); };
    var methods = {
        get: function (query) {
            return get(Urls_1.getUrl(url, query));
        },
        post: function (data) {
            return post(url, data);
        },
        put: function (data) {
            return put(url, data);
        },
        patch: function (data) {
            return put(url, data);
        },
        delete: function () {
            return del(url);
        },
    };
    return Object.assign(func, methods, { $id: $id, $url: url, $fetchFuncs: { get: get, post: post, put: put, del: del, patch: patch } });
}
exports.apiNode = apiNode;
//# sourceMappingURL=ApiNode.js.map